---@meta

---@class HttpOptions
---@field query table
---@field body table
---@field headers table

---@class Http
---@field get fun(self: Http, url: string, httpOptions: HttpOptions): any, string
---@field post fun(self: Http, url: string, httpOptions: HttpOptions): any, string
---@field patch fun(self: Http, url: string, httpOptions: HttpOptions): any, string
---@field put fun(self: Http, url: string, httpOptions: HttpOptions): any, string
---@field delete fun(self: Http, url: string, httpOptions: HttpOptions): any, string
---@field head fun(self: Http, url: string, httpOptions: HttpOptions): table, string

http = {} ---@type Http
